/* eslint-disable no-console */
/* eslint-disable react/no-danger */
/* eslint-disable arrow-body-style */
import React from 'react'
import SectionCta from '@components/Button/button'
import { convertToSlug } from 'src/utils/IdGenerator'
import ErrorBoundary from '@components/ErrorBoundary/errorBoundary'
import styles from './joinMillion.module.scss'

const joinMillion = ({ data }) => {
  const jmdData = data?.data?.attributes

  const cheerio = typeof window === 'undefined' ? global.cheerio : window.cheerio

  // for id assign
  const h2Regex = /<h2[^>]*>(.*?)<\/h2>/
  const matches = data?.data?.attributes.sectionHeading.match(h2Regex)
  const h2Content = matches ? matches[1] : null

  const getModifiedHtml = tableContent => {
    const $ = cheerio.load(tableContent, null, false)

    $('p').each((_index, element) => {
      const $p = $(element)
      if ($p.html().trim() === '&nbsp;') {
        $p.remove()
      }
    })

    $('a').each((_index, element) => {
      const $a = $(element)
      $a.attr('target', '_blank')
    })

    const modifiedHTML = $.html()
    return modifiedHTML
  }

  return (
    <ErrorBoundary data={data}>
      <div className={styles.joinMillionRootContainer} id={convertToSlug(h2Content)}>
        <div
          className={styles.sectionHeading}
          dangerouslySetInnerHTML={{ __html: getModifiedHtml(jmdData.sectionHeading) }}
        />
        <div className={styles.gridSectionForData}>
          {jmdData?.sectionData?.map(item => {
            return (
              <div className={styles.joinMillionDataContainer} key={item.id}>
                <h3>{item.ackoMetricValue}</h3>
                <p>{item.ackoMetricName}</p>
              </div>
            )
          })}
        </div>
        {jmdData?.sectionCta?.name && (
          <div className={styles.sectionCta}>
            <SectionCta data={jmdData?.sectionCta} segmentEventCommonProperties={data?.segmentEventCommonProperties} />
          </div>
        )}
      </div>
    </ErrorBoundary>
  )
}

export default joinMillion
